import Service from "./Service";

export default class CouponValidationService extends Service {
    constructor() {
        super();
    }

    applyCoupon(coupon) {
        return this.axios.post('/validate/coupon', {coupon});
    }
}